(document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".testTab"),
    contents = document.querySelectorAll(".testContent");
  (tabs[0].classList.add("active-tab"),
    contents[0].classList.add("active-content"),
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        (tabs.forEach((t) => t.classList.remove("active-tab")),
          contents.forEach((c) => c.classList.remove("active-content")),
          tab.classList.add("active-tab"),
          contents[index].classList.add("active-content"));
      });
    }));
}),

  document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".scrollingSliderItems");
    if (!container) return;
    const boxes = Array.from(container.querySelectorAll(".scrollSlideText"));
    const CLONE_COUNT = 3;
    for (let i = 0; i < CLONE_COUNT; i++) {
      boxes.forEach((box) => {
        container.appendChild(box.cloneNode(true));
      });
    }
    const scrollDistance = container.scrollWidth / 2;
    const SPEED = 40;
    const duration = scrollDistance / SPEED;
    const animation = gsap.to(container, {
      x: -scrollDistance,
      duration: duration,
      ease: "linear",
      repeat: -1,
    });
    container.addEventListener("mouseenter", () => animation.pause());
    container.addEventListener("mouseleave", () => animation.resume());
  }));

function forFaq() {
  const accordionSections = document.querySelectorAll(".faqCntntItems");

  accordionSections.forEach((section) => {
    const accordionItemHeaders = section.querySelectorAll(
      ".accordion-item-header",
    );

    if (accordionItemHeaders.length > 0) {
      const firstAccordionItemHeader = accordionItemHeaders[0];
      const firstAccordionItemBody =
        firstAccordionItemHeader.nextElementSibling;

      firstAccordionItemHeader.classList.add("active");
      firstAccordionItemBody.style.maxHeight =
        firstAccordionItemBody.scrollHeight + "px";
    }

    accordionItemHeaders.forEach((accordionItemHeader) => {
      accordionItemHeader.addEventListener("click", (event) => {
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        accordionItemHeaders.forEach((item) => {
          if (item !== accordionItemHeader) {
            item.classList.remove("active");
            item.nextElementSibling.style.maxHeight = 0;
          }
        });
        accordionItemHeader.classList.toggle("active");
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight =
            accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      });
    });
  });
}
forFaq();

{
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".main-slid-wrp").forEach((container) => {
      const handle = container.querySelector(".slider-button-riz");
      let isDragging = false;
      const updateSlider = (clientX) => {
        const rect = container.getBoundingClientRect();
        let x = clientX - rect.left;
        let percentage = (x / rect.width) * 90;
        percentage = Math.max(10, Math.min(90, percentage));
        container.style.setProperty("--position", `${percentage}%`);
      };
      const startDrag = (e) => {
        isDragging = true;
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        updateSlider(clientX);
      };
      const drag = (e) => {
        if (!isDragging) return;
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        updateSlider(clientX);
      };
      const endDrag = () => {
        isDragging = false;
      };
      container.addEventListener("mousedown", startDrag);
      container.addEventListener("touchstart", startDrag, { passive: true });
      window.addEventListener("mousemove", drag);
      window.addEventListener("touchmove", drag, { passive: true });
      window.addEventListener("mouseup", endDrag);
      window.addEventListener("touchend", endDrag);
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.querySelector(".facets--filters-title");
  const target = document.querySelector(".filtSideInnerHldr");

  if (!toggleBtn || !target) return;

  // 🔹 Default state: both active
  toggleBtn.classList.add("activeFilter");
  target.classList.add("activeFilter");

  toggleBtn.addEventListener("click", function () {
    toggleBtn.classList.toggle("activeFilter");
    target.classList.toggle("activeFilter");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const videoBoxes = document.querySelectorAll(".why-choose-video-box, .videoBox");
  let currentlyPlaying = null;
  videoBoxes.forEach((box) => {
    const video = box.querySelector("video");
    const playBtn = box.querySelector(".video-playBtn");
    playBtn.addEventListener("click", function () {
      if (currentlyPlaying === video) {
        video.pause();
        box.classList.remove("active");
        playBtn.classList.remove("active");
        currentlyPlaying = null;
        return;
      }
      if (currentlyPlaying) {
        currentlyPlaying.pause();
        currentlyPlaying
          .closest(".why-choose-video-box, .videoBox")
          .classList.remove("active");
        currentlyPlaying
          .closest(".why-choose-video-box, .videoBox")
          .querySelector(".video-playBtn")
          .classList.remove("active");
      }
      video.play();
      box.classList.add("active");
      playBtn.classList.add("active");
      currentlyPlaying = video;
    });
    video.addEventListener("pause", function () {
      if (currentlyPlaying === video) {
        box.classList.remove("active");
        playBtn.classList.remove("active");
        currentlyPlaying = null;
      }
    });
    video.addEventListener("ended", function () {
      box.classList.remove("active");
      playBtn.classList.remove("active");
      currentlyPlaying = null;
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((accordion) => {
    const detailsElements = accordion.querySelectorAll("details");
    detailsElements.forEach((detail) => {
      detail.addEventListener("toggle", function () {
        if (this.open) {
          detailsElements.forEach((otherDetail) => {
            if (otherDetail !== this && otherDetail.open) {
              otherDetail.open = false;
            }
          });
        }
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const charts = document.querySelectorAll(".circular-chart");
  charts.forEach((chart) => {
    const text = chart.querySelector(".percentage");
    const circle = chart.querySelector(".circle");
    if (text && circle) {
      const percentage = parseInt(text.textContent);
      const dashArray = `${percentage}, 100`;
      circle.style.strokeDasharray = dashArray;
      circle.classList.add("animate");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function countview(element) {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom >= 0;
  }
  function countwrpnew() {
    const sections = document.querySelectorAll(
      ".counter-box:not(.activeCount)",
    );
    sections.forEach((section) => {
      if (countview(section)) {
        section.classList.add("activeCount");
      }
    });
  }
  window.addEventListener("scroll", countwrpnew);
  window.addEventListener("load", countwrpnew);
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".scroll-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      let target = this.getAttribute("data-target");

      if (target && !target.startsWith('.') && !target.startsWith('#')) {
        target = '#' + target;
      }

      const targetEl = document.querySelector(target);

      if (targetEl) {
        targetEl.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const section = document.getElementById("stickyProductCTA");
  if (!section) return;
 
  const targetSelector = section.dataset.target;
  const target = document.querySelector(targetSelector);
  const button = section.querySelector(".cta-btn");
 
  if (!target) return;
 
  // Show / Hide on scroll
  function toggleSticky() {
    const targetBottom = target.getBoundingClientRect().bottom;
 
    if (targetBottom < 0) {
      section.classList.add("active");
    } else {
      section.classList.remove("active");
    }
  }
 
  window.addEventListener("scroll", toggleSticky);
  toggleSticky(); // on load
 
  // Smooth scroll on click
  button.addEventListener("click", function () {
    document.querySelector(targetSelector).scrollIntoView({
      behavior: "smooth"
    });
  });
});

  {
    document.addEventListener('DOMContentLoaded', function () {
    const boxes = document.querySelectorAll('.stepsBoxesHldr .stepsBox');

    if (!boxes.length) return;

    let currentIndex = 0;
    let interval;

    function setActive(index) {
      boxes.forEach((box) => {
        box.classList.remove('boxActive');
        box.style.setProperty('--line-duration', '0s');
        const content = box.querySelector('.stepBoxCntnt');
        if (content) {
          content.style.maxHeight = '0';
        }
      });

      void document.body.offsetHeight;

      const activeBox = boxes[index];

      activeBox.style.setProperty('--line-duration', '3s');
      activeBox.classList.add('boxActive');

      const activeContent = activeBox.querySelector('.stepBoxCntnt');
      if (activeContent) {
        activeContent.style.maxHeight = activeContent.scrollHeight + 'px';
      }

      currentIndex = index;
    }

    function startAutoplay() {
      clearInterval(interval);

      interval = setInterval(() => {
        currentIndex = (currentIndex + 1) % boxes.length;
        setActive(currentIndex);
      }, 3000);
    }

    setActive(0);
    startAutoplay();

    boxes.forEach((box, index) => {
      box.addEventListener('click', () => {
        setActive(index);
        startAutoplay();
      });
    });
  });
}